import { useEffect, useMemo } from 'react';
import { getKeysFromSessionStorage, readFromSessionStorage, saveToSessionStorage } from 'framework-listing-lib/utils/sessionStorage';
import { safeParseJSON } from 'framework-listing-lib/utils/json';
import { useCurrentViewId, useViewsNamespace } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import useObjectTypeId from './useObjectTypeId';
export default function useSyncFiltersWithSessionStorage({
  filterGroups,
  quickFilters,
  skip
}) {
  const currentViewId = useCurrentViewId();
  const objectTypeId = useObjectTypeId();
  const namespace = useViewsNamespace();
  const sessionStorageKey = useMemo(() => currentViewId ? `ListingLibFilterState:${objectTypeId}:${currentViewId}:${namespace}` : undefined, [currentViewId, namespace, objectTypeId]);
  useEffect(() => {
    if (!sessionStorageKey || skip) {
      return;
    }
    saveToSessionStorage(sessionStorageKey, JSON.stringify({
      filterGroups: filterGroups || [{
        filters: []
      }],
      quickFilters: quickFilters || []
    }));
  }, [filterGroups, quickFilters, sessionStorageKey, skip]);
  useEffect(() => {
    if (skip) {
      getKeysFromSessionStorage().filter(key => key.startsWith(`ListingLibFilterState`)).forEach(key => {
        sessionStorage.removeItem(key);
      });
    }
  }, [skip]);
  return useMemo(() => {
    if (!skip && sessionStorageKey) {
      return safeParseJSON(readFromSessionStorage(sessionStorageKey), undefined);
    }
    return undefined;
  }, [sessionStorageKey, skip]);
}